var TAG_APPEARANCES = ['success', 'warning', 'danger'];
var TAG_ELEMS = ['button', 'a', 'div'];

export { TAG_APPEARANCES, TAG_ELEMS };
